import React from "react";
import cx from "classnames";
var NavText = function NavText(_ref) {
  var id = _ref.id,
    title = _ref.title,
    href = _ref.href,
    onClick = _ref.onClick,
    active = _ref.active,
    navActive = _ref.navActive,
    _ref$isShow = _ref.isShow,
    isShow = _ref$isShow === void 0 ? true : _ref$isShow,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$innerClassName = _ref.innerClassName,
    innerClassName = _ref$innerClassName === void 0 ? "" : _ref$innerClassName;
  return isShow ? (/*#__PURE__*/React.createElement("div", {
    id: id,
    style: style,
    className: cx("tc-top-nav-item", {
      active: active === navActive
    })
  }, /*#__PURE__*/React.createElement("a", {
    className: cx("tc-top-nav-link", "".concat(innerClassName)),
    href: href,
    onClick: onClick,
    target: '_blank',
    rel: 'noreferrer'
  }, title))) : null;
};
export default NavText;